"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgContinuousMedicine = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M2 7.994h9S7 9.5 7 15s4 6.981 4 6.981 1 .025-7 0c-1.333 0-2-.666-2-1.998V7.994zM3.038 2H19c1.333 0 2 .666 2 1.998V6H1V3.998C1 2.666 1.68 2 3.038 2z' }),
    react_1.default.createElement("path", { d: 'M12.636 8.861A7 7 0 0121 10.101V8.5s0-1 1-1 1 1 1 1v4c0 1-1 1-1 1h-4s-1 0-1-1c0-.95 1-.95 1-.95h1.622a5.003 5.003 0 101.28 4.444c.11-.54.548-.991 1.1-.991.55 0 1.005.45.926.996A7 7 0 1112.636 8.86z' }))); };
exports.default = SvgContinuousMedicine;
//# sourceMappingURL=ContinuousMedicine.js.map